import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const ibwfitnessApiService = createApi({
  reducerPath: "ibwfitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createIBW: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `ibwfitness/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getIBW: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `ibwfitness/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateIBW: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `ibwfitness/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const { useCreateIBWMutation, useGetIBWQuery, useUpdateIBWMutation } =
  ibwfitnessApiService;
